import React from 'react';
import { Radio } from 'antd';
import { QuoteLineItemProps } from '@partsbadger/types';
import dayjs from 'dayjs';
import { LeadTimeOptionCard } from './LeadTimeOptionCard';

export interface LeadTimePriceOptionsProps {
    lineItem: QuoteLineItemProps;
    handleChange?: (value: string) => void;
    loading?: boolean;
    onChange?: (value: string | number) => void;
    /** 'grid' = horizontal wrap; 'column' = stack vertically */
    direction?: 'grid' | 'column';
}

const orderedTypes = ['Expedited', 'Standard'] as const;

export const LeadTimePriceOptions: React.FC<LeadTimePriceOptionsProps> = ({
    lineItem,
    handleChange,
    loading = false,
    onChange,
    direction = 'grid',
}) => {
    const options = lineItem?.pricing_options?.prices_by_quantity?.[lineItem?.quantity] ?? [];
    const selectedValue =
        options.find(opt => opt.lead_time === lineItem?.lead_time)?.id ?? options?.[0]?.id;

    const orderedOptions = orderedTypes.flatMap(type =>
        options.filter(opt => opt?.type === type)
    );

    const isColumn = direction === 'column';
    const containerStyle: React.CSSProperties = {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 6,
        flexDirection: isColumn ? 'column' : 'row',
    };

    const itemWrapperStyle: React.CSSProperties = isColumn
        ? { width: '100%' }
        : { flex: '0 1 240px', minWidth: 200 };

    return (
        <Radio.Group
            value={selectedValue ?? undefined}
            onChange={e => {
                const v = e.target.value;
                onChange?.(v);
                handleChange?.(v);
            }}
        >
            <div style={containerStyle}>
                {orderedOptions.map(option => (
                    <div key={option?.id} style={itemWrapperStyle}>
                        <LeadTimeOptionCard
                            option={option}
                            lineItem={lineItem}
                            readonly={handleChange === undefined}
                            isDisabled={
                                handleChange === undefined &&
                                dayjs(option?.expiration_date).isBefore(dayjs())
                            }
                            loading={loading}
                            isSelected={option?.id === selectedValue}
                        />
                    </div>
                ))}
            </div>
        </Radio.Group>
    );
};
